var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGreenCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 94,
    viewBox: "0 0 95 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_220_3105",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 95,
    height: 94
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 94,
    height: 94,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_220_3105)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.5835 66.5835H51.4168V50.9168H67.0835V43.0835H51.4168V27.4168H43.5835V43.0835H27.9168V50.9168H43.5835V66.5835ZM47.5002 86.1668C42.0821 86.1668 36.9904 85.1387 32.2252 83.0825C27.4599 81.0262 23.3147 78.2356 19.7897 74.7106C16.2647 71.1856 13.4741 67.0404 11.4179 62.2752C9.36162 57.5099 8.3335 52.4182 8.3335 47.0002C8.3335 41.5821 9.36162 36.4904 11.4179 31.7252C13.4741 26.9599 16.2647 22.8147 19.7897 19.2897C23.3147 15.7647 27.4599 12.9741 32.2252 10.9179C36.9904 8.86162 42.0821 7.8335 47.5002 7.8335C52.9182 7.8335 58.0099 8.86162 62.7752 10.9179C67.5404 12.9741 71.6856 15.7647 75.2106 19.2897C78.7356 22.8147 81.5262 26.9599 83.5825 31.7252C85.6387 36.4904 86.6668 41.5821 86.6668 47.0002C86.6668 52.4182 85.6387 57.5099 83.5825 62.2752C81.5262 67.0404 78.7356 71.1856 75.2106 74.7106C71.6856 78.2356 67.5404 81.0262 62.7752 83.0825C58.0099 85.1387 52.9182 86.1668 47.5002 86.1668Z",
    fill: "url(#paint0_linear_220_3105)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_220_3105",
    x1: 47.5002,
    y1: 7.8335,
    x2: 47.5002,
    y2: 86.1668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.526042,
    stopColor: "#B7F133"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42E365"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenCircle);
export default __webpack_public_path__ + "static/media/green-circle.59837120fb21b196184ae5609192097b.svg";
export { ForwardRef as ReactComponent };